module.exports = __webpack_public_path__ + "img/image-mt-3.1a5f3097.png";